/* This example requires Tailwind CSS v2.0+ */
import React from "react"
import { CheckIcon } from "@heroicons/react/outline"

const features = [
  {
    name: "Open Cyber Range",
    description:
      "OCR is a virtual environment used for cybersecurity training and technology testing and development. The CR14’s OCR platform will include tools and products that are not part of standard cloud service. In addition to providing a platform for cybersecurity companies to develop, test and validate their innovative products, it also creates a launchpad for new products to emerge into the market and promotes security thinking and cybersecurity educational activities, especially in the private sector. OCR will also be one of the test bases for NATO DIANA.",
  },
  {
    name: "Estonian Cyber Range",
    description:
      "The Estonian national CR provides national and bi-lateral cyber defence training and is the home base for the world´s largest international cyber exercises such as Locked Shields and Crossed Swords. In addition, CR14 as well as the NATO CCDCOE use this CR for research and development. Since NATO’s 2014 Wales Summit its infrastructure serves as the basis for the creation of the NATO Cyber Range. The Estonian national CR is based on more than ten years of operating experience, arguably being one of the earliest establishments of its kind globally.",
  },
  {
    name: "NATO Cyber Range",
    description:
      "NATO CR is a platform and data centre enabling NATO to conduct its largest cyber defence exercises and training such as the Cyber Coalition and the Coalition Warrior Interoperability eXercise (CWIX). CR14 is proud of the opportunity to serve the development of NATO’s capacity in this area since 2014 and to support Allies in achieving better preparedness for cyber-attacks.",
  },
  {
    name: "Classified Cyber Range",
    description:
      "Our mission is to explore the art of cybersecurity which might sometimes extend beyond the limits of unclassified.",
  },
]

export default function LandingMiddleSection() {
  return (
    <div className="bg-gradient-to-r from-gray-50 via-white to-blue-50">
      <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:py-24 lg:px-8 lg:grid lg:grid-cols-3 lg:gap-x-8">
        <div>
          <p className="mt-2 text-3xl font-extrabold text-gray-900">
            Cyber Range
          </p>
          <p className="mt-4 text-lg text-gray-500">
            Cyber Range is a unique software-based virtual environment that is
            used for cybersecurity training and for the development of dual-use
            innovative technologies using cyberspace. It provides tools that
            help to strengthen the security and performance of cyber-physical
            and IT systems of private companies and national and international
            organizations (such as NATO and the EU) leading to secure
            trustworthy products and cyber-savvy personnel. Cyber ranges are by
            essence high-performance data centres, built to provide the basis
            for real-life scenario-based live-fire and table-top exercises for
            companies and national teams to test, validate and develop their
            cyber security products, readiness, and capability.
          </p>
        </div>
        <div className="mt-12 lg:mt-0 lg:col-span-2">
          <dl className="space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:grid-rows-2 sm:grid-flow-col sm:gap-x-6 sm:gap-y-10 lg:gap-x-8">
            {features.map(feature => (
              <div
                key={feature.name}
                className="relative transform duration-75 ease-in translate-y-0 scale-95 hover:translate-y-2 hover:scale-100  bg-transparent hover:bg-gray-100 hover:shadow-sm pr-5 p-5"
              >
                <dt>
                  <CheckIcon
                    className="absolute h-6 w-6 text-green-500"
                    aria-hidden="true"
                  />
                  <p className="ml-9 text-lg leading-6 font-medium text-gray-900">
                    {feature.name}
                  </p>
                </dt>
                <dd className="mt-2 ml-9 text-base text-gray-500">
                  {feature.description}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  )
}
